require('./hireNewPaymentSimulator.scss');

import React, {useState} from 'react';

import { i18n } from 'core/i18n';
import { formatAmountObject } from 'utilities/currencyHelper';
import DateHelper from 'utilities/dateHelper';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import {
    DATE_FORMAT_ES,
    EURO_TEXT,
} from 'constants/index';
const { FormattedText, getLanguage } = i18n;

const HireNewPaymentSimulator = ({ immPdfRevolvingPersistent, activeTab }) => {

    const firstPaymentDate = DateHelper.buildFormattedDate(
        immPdfRevolvingPersistent.get('firstPaymentDate'),
        DATE_FORMAT_ES
    );
    const lastPaymentDate = DateHelper.buildFormattedDate(
        immPdfRevolvingPersistent.get('lastPaymentDate'),
        DATE_FORMAT_ES
    );
    const monthsTerm = immPdfRevolvingPersistent.get('monthsTerm')
    const firstPaymentAmount = {
        amount: immPdfRevolvingPersistent.get('firstPaymentAmount'),
        currency: EURO_TEXT
    }
    const lastPaymentAmount = {
        amount: immPdfRevolvingPersistent.get('lastPaymentAmount'),
        currency: EURO_TEXT
    }
    const totalAmountOwed = {
        amount: immPdfRevolvingPersistent.get('totalAmountOwed'),
        currency: EURO_TEXT
    }
    const financedAmount = {
        amount: immPdfRevolvingPersistent.get('financedAmount'),
        currency: EURO_TEXT
    }
    const totalInterest = {
        amount: immPdfRevolvingPersistent.get('totalInterest'),
        currency: EURO_TEXT
    }

    return (
        <>
            <div className="hire-new-payment-simulator__container">
                <div className="hire-new-payment-simulator__summary-container pt-4 pb-2 pb-md-4">
                    <div className="row">

                        <div className="col-sm-4 pl-4 pl-md-5">
                            <div className="row">
                                <div className="col-7 col-sm-12">
                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-firstPaymentDate"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator__text pr-4 col-data-right">
                                    <span>{firstPaymentDate}</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4 mt-2 mt-sm-0 pl-4 pl-md-3">
                            <div className="row">
                                <div className="col-7 col-sm-12">
                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-lastPaymentDate"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>{lastPaymentDate}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row hire-new-payment-simulator__header mt-md-4">

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-5 hidden-on-mobile">
                            <div className="row">
                                <div className="col-7 col-sm-12">
                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-monthsTerm"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>{monthsTerm}</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-3">
                            <div className="row">
                                <div className="col-7 col-sm-12">

                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-firstPaymentAmount"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>
                                        <OneLineSymbolAmount
                                            amountObject={firstPaymentAmount}
                                            language={getLanguage()}
                                            amountObjectFormatted={formatAmountObject(firstPaymentAmount, true)}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-3">
                            <div className="row">
                                <div className="col-7 col-sm-12">
                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-lastPaymentAmount"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>
                                        <OneLineSymbolAmount
                                            amountObject={lastPaymentAmount}
                                            language={getLanguage()}
                                            amountObjectFormatted={formatAmountObject(lastPaymentAmount, true)}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hire-new-payment-simulator__results-container pt-4 pb-2 pb-md-4">
                    <div className="row hire-new-payment-simulator__header mt-md-4">

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-5 hidden-on-mobile">
                            <div className="row">
                                <div className="col-7 col-sm-12">
                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-totalAmountOwed"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>  <OneLineSymbolAmount
                                        amountObject={totalAmountOwed}
                                        language={getLanguage()}
                                        amountObjectFormatted={formatAmountObject(totalAmountOwed, true)}
                                    />
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-3">
                            <div className="row">
                                <div className="col-7 col-sm-12">

                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-financedAmount"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>  <OneLineSymbolAmount
                                        amountObject={financedAmount}
                                        language={getLanguage()}
                                        amountObjectFormatted={formatAmountObject(financedAmount, true)}
                                    /></span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-3">
                            <div className="row">
                                <div className="col-7 col-sm-12">
                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-totalInterest"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span><OneLineSymbolAmount
                                        amountObject={totalInterest}
                                        language={getLanguage()}
                                        amountObjectFormatted={formatAmountObject(totalInterest, true)}
                                    /> </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hire-new-payment-simulator__percentage pt-4 pb-2 pb-md-4">
                    <div className="row hire-new-payment-simulator__header mt-md-4">

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-5 hidden-on-mobile">
                            <div className="row">
                                <div className="col-7 col-sm-12">
                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-termMax"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>   <FormattedText
                                        value="hireNewCreditCard-48cuotes"
                                    />
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-3">
                            <div className="row">
                                <div className="col-7 col-sm-12">

                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-tin"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>{immPdfRevolvingPersistent.getIn(['paramsInne', 'tin'])}</span>

                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4 mt-2 mt-md-0 pl-4 pl-md-3">
                            <div className="row">
                                <div className="col-7 col-sm-12">
                                    <label>
                                        <FormattedText
                                            value="hireNewCreditCard-tae"
                                        />
                                    </label>
                                </div>
                                <div className="col-5 col-sm-12    hire-new-payment-simulator-text pr-4 col-data-right">
                                    <span>{immPdfRevolvingPersistent.getIn(['paramsInne', 'tae'])}</span>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HireNewPaymentSimulator;
